export enum PortalStatus {
  Unknown,
  Locked,
  PendingActivation,
  Activated,
  Mismatched,
  Error
}
